module.exports = __webpack_public_path__ + "img/r_k.ee1a6e77.svg";